import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert2';
import { isNullOrUndefined } from 'util';

import { ServicesService } from '../services/services.service';
import { markAsTouchDeep } from '../shared/models/form-utilities';
import { MapsContentComponent } from './maps-modal/maps-content.component';
import { MapsModalComponent } from './maps-modal/modal-container/maps-modal.component';

@Component({
  selector: 'app-create-loadhseet-delivery',
  templateUrl: './create-loadhseet-delivery.component.html',
  styleUrls: ['./create-loadhseet-delivery.component.css']
})
export class CreateLoadhseetDeliveryComponent implements OnInit {

  form: FormGroup;

  initialFormState = {

  }

  //variable for search fields (orders)
  empList = [];
  branchList = [];
  orders = [];
  selectedOrders = [];
  selectedClients = [];

  selectedItems = [];
  clientDropdownSettings: any = {};
  orderDropdownSettings: any = {};

  ShowFilter = true;
  showLoader: boolean = false;
  searchPropertyForm: FormGroup;

  // variable defined for static data
  productList = [];
  componentList = [];
  new_qty = [];

  @ViewChild('search')
  public searchElementRef: ElementRef;

  /*----------------------------------Google API--------------------------------*/
  deliveryDetails: Object = {}
  routeLocation: string;

  latitude: number = -25.717530;
  longitude: number = 28.031360;
  public address: string;

  public dataToSend: Object = {};
  requestedMap: string;

  mapTitle: string;
  closeResult: string;
  mapFor: string;
  isLoader: boolean = false;

  routePath: any;
  clientList = [];
  clientId: any;

  isCreatedLoadsheet = false;

  get emailForm(): FormGroup {
    return this.form.controls['emails'] as FormGroup;
  }

  get loadsheetDetailsForm(): FormGroup {
    return this.form.controls['loadsheet_details_form'] as FormGroup;
  }


  orderProducts(orderId: number): any[] {
    return this.new_qty[orderId];
  }

  // returns a product from the retrieved ProductList in a usable format
  productInfo(orderId: number, productId: number): any {
    // This is in some weird dictionary list style.
    return this.productList[orderId][productId];
  }

  productName(orderId: number, productId: number): string {
    return this.productInfo(orderId, productId).product_name;
  }

  constructor(private modalService: NgbModal,
    private mapsAPILoader: MapsAPILoader,
    private _service: ServicesService,
    private router: Router) {

    this.initializeForm()
  }

  ngOnInit() {
    this._service.checkToken('status');
    this.generateClientDropdown();
    //static Data

    let now = new Date();
    let currentMont = now.getMonth() + 1;
    let randomNumPart = Math.floor((Math.random() * 99)).toString().padStart(2, '0');

    const loadsheetNo = `${now.getDate()}${currentMont}${now.getFullYear()}${randomNumPart}`;

    this.form.get('loadsheet_no').setValue(loadsheetNo);
    this.form.get('delivery_no').setValue(loadsheetNo);
  }

  initializeForm() {
    this.form = new FormBuilder().group({
      loadsheet_no: [{ value: '', disabled: true }, []],
      branch_id: ['', [Validators.required]],
      loadsheet_date: ['', Validators.required],
      clientList: ['', [Validators.required]],
      orders: ['', Validators.required],
      loadsheet_emp_id: ['', Validators.required],
      loadsheet_details_form: new FormBuilder().group({
        school: [false],
        household: [false],
        school_name: [''],
      }, { validator: this.validateLoadsheetDetails() }),
      delivery_no: [{ value: '', disabled: true }, []],
      delivery_date: ['', Validators.required],
      delivery_address: ['', Validators.required],
      transport_company: ['', Validators.required],
      emails: new FormBuilder().group({
        email_1: [''],
        email_2: [''],
        email_3: [''],
        email_4: [''],
      }, { validator: this.atLeastOneValidator([Validators.required, Validators.email]) }),
      contact_person_name: ['', Validators.required],
      contact_person_mobile: ['', Validators.required],
      delivery_emp_id: ['', Validators.required]
    });
  }

  resetForm() {
    this.form.reset(this.initialFormState);
    this.latitude = -25.717530;
    this.longitude = 28.031360;
  }

  openAddressDialog() {
    const modalRef = this.modalService.open(MapsModalComponent, { size: 'lg' });

    modalRef.componentInstance.mapTitle = 'Select your area';
    // This should trigger OnChanges on the mapsContent, and update the map.
    modalRef.componentInstance.latitude = this.latitude;
    modalRef.componentInstance.longitude = this.longitude;
    modalRef.componentInstance.address = this.address;

    modalRef.result.then((location: { address: string, lat: number, lng: number }) => {
      if (!isNullOrUndefined(location)) {
        this.form.get('delivery_address').setValue(location.address);
        this.latitude = location.lat;
        this.longitude = location.lng;
        this.address = location.address;
      }
    });
  }

  searchPlaces() {
    this.mapsAPILoader.load().then(() => {
      let deliveryAddressAutocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["geocode"],
        componentRestrictions: { country: ["na", "ls", "za"] }
      });

      //---------------------------load Places Autocomplete-----------
      deliveryAddressAutocomplete.addListener("place_changed", () => {
        // get the place result
        let place: google.maps.places.PlaceResult = deliveryAddressAutocomplete.getPlace();
        // verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        //set latitude, longitude and zoom
        this.address = place.formatted_address;
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
      });
    });
  }

  /*----------------------------------Google API--------------------------------*/

  //function to generate client dropdown list
  generateClientDropdown() {
    this.getClientList();
    this.clientDropdownSettings = {
      singleSelection: true,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      closeDropDownOnSelection: true,
      itemsShowLimit: 1,
      allowSearchFilter: this.ShowFilter,
      noDataAvailablePlaceholderText: 'No Client Found',
    };
  }

  //function to generate order dropdown list
  generateOrderDropdown(clientId: number) {
    this.getOrdersProductsComponents(clientId);
    this.orderDropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: this.ShowFilter,
      noDataAvailablePlaceholderText: 'No Order Placed. Create New order of this client',
    };
  }

  getClientList() {
    this.showLoader = true;

    this.routePath = 'get-all-client-list';
    var data = {
    }
    const token = localStorage.getItem('userToken');
    this._service.requestCreator(data, this.routePath, token).subscribe((result: any) => {
      this.showLoader = false;
      if (this._service.checkToken(result.status)) {
        // this.clientList = result.result;
        this.clientList = [];
        for (let element in result.result.clients) {
          let data = {
            'item_id': result.result.clients[element].client_id,
            'item_text': result.result.clients[element].client_name,
          }
          this.clientList.push(data);
        }
        this.branchList = result.result.branchData;
      }
    });
    return true;
  }

  getOrdersProductsComponents(clientId: number): void {

    this.showLoader = true;

    this.routePath = 'get-orders-products-components-list';
    let data = {
      "client_id": clientId,
    }
    const token = localStorage.getItem('userToken');
    this._service.requestCreator(data, this.routePath, token).subscribe((data: any) => {

      this.showLoader = false;
      
      if (this._service.checkToken(data.status)) {
        this.empList = data.result.empData;
        this.orders = [];

        for (let element in data.result.orders) {
          let order = {
            'item_id': data.result.orders[element].item_id,
            'item_text': data.result.orders[element].item_text + ' (' + data.result.orders[element].client_name + ')'
          }
          this.orders.push(order);
        }

        this.productList = [];
        this.productList = data.result.products;
        this.componentList = data.result.components;
        this.new_qty = data.result.new_qty;
      }
    });
  }

  // function to push json object in selectedItemList.
  onOrderSelect(order: any) {

    const orderControl = this.form.controls['orders'];

    this.selectedOrders.push(order)
    this.form.controls['orders'].setValue(this.selectedOrders);


    orderControl.markAsTouched();
    orderControl.setValue(this.selectedOrders);
  }

  //for client module
  onSelectClient(item: any) {
    
    const clientListControl = this.form.get('clientList');

    clientListControl.setValue(item);
    clientListControl.markAsTouched();

    this.form.controls['orders'].setValue('');
    this.selectedOrders = [];

    this.generateOrderDropdown(item.item_id);
    this.selectedClients = [];
    this.selectedClients.push(item);
  }

  onOrderDeselect(items: any) {
    const orderControl = this.form.controls['orders'];

    let index = this.selectedOrders.findIndex(x => x.item_id == items.item_id);
    this.selectedOrders.splice(index, 1);

    orderControl.setValue(this.selectedOrders.length === 0 ? null : this.selectedOrders);
  }

  onDeselectClient(item: any) {
    this.form.get('clientList').setValue(null);
    this.orders = [];
    this.form.controls['orders'].setValue('');
  }

  onSelectAllOrders(orders: any[]) {
    this.selectedOrders = [];
    for (let order of orders) {
      this.selectedOrders.push(order);
    }

    this.form.controls['orders'].setValue(this.selectedOrders);
  }

  onDeSelectAllOrders(item: any) {
    this.selectedOrders = [];
    this.form.controls['orders'].setValue(null);
  }

  createLoadsheetDelivery() {

    this.routePath = 'create-loadsheet-delivery';
    const token = localStorage.getItem('userToken');
    const formData = this.extractFormData();
    
    this.showLoader = true;
    this._service.requestCreator(formData, this.routePath, token).subscribe((result: any) => {
      this.showLoader = false;
      if (this._service.checkToken(result.status)) {
        if (result.status == 200) {

          this.isCreatedLoadsheet = true;
          swal({
            title: 'Loadsheet Delivery Added.',
            text: 'You Successfully Added.',
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: 'rgb(17, 205, 239)',
            cancelButtonColor: 'rgb(245, 54, 92)',
            confirmButtonText: 'Yes'
          }).then(() => {
            this.resetForm();
            this.router.navigateByUrl('/loadsheets');
            this.isCreatedLoadsheet = false;
          });
        } else {
          swal({
            title: 'Loadsheet Delivery Fail.',
            text: result.message,
            type: 'warning',
            showCancelButton: false,
            confirmButtonColor: 'rgb(17, 205, 239)',
            cancelButtonColor: 'rgb(245, 54, 92)',
            confirmButtonText: 'Yes'
          }).then(() => {
            this.isCreatedLoadsheet = false;
          })
        }
      }
    });
  }

  private extractFormData(): any {
    const result = {
      new_qty: this.new_qty,
      
      loadsheet_no: this.form.get('loadsheet_no').value,
      branch_id: this.form.get('branch_id').value,
      loadsheet_date: this.form.get('loadsheet_date').value,
      loadsheet_emp_id: this.form.get('loadsheet_emp_id').value,
      orders: this.form.get('orders').value,
      delivery_no: this.form.get('delivery_no').value,
      delivery_date: this.form.get('delivery_date').value,
      transport_company: this.form.get('transport_company').value,
      email_1: this.form.get('emails.email_1').value,
      email_2: this.form.get('emails.email_2').value,
      email_3: this.form.get('emails.email_3').value,
      email_4: this.form.get('emails.email_4').value,
      contact_person_name: this.form.get('contact_person_name').value,
      contact_person_mobile: this.form.get('contact_person_mobile').value,
      delivery_emp_id: this.form.get('delivery_emp_id').value,
      delivery_address: this.form.get('delivery_address').value,
      delivery_latitude: this.latitude,
      delivery_longitude: this.longitude,
      household: this.form.get('loadsheet_details_form.household').value,
      school: this.form.get('loadsheet_details_form.school').value,
      school_name: this.form.get('loadsheet_details_form.school_name').value,
    };

    return result;

    // formData: any = {
    //   loadsheet_no: '',
    //   branch_id: '',
    //   loadsheet_date: '',
    //   loadsheet_emp_id: '',
    //   orders: [],
    //   delivery_no: '',
    //   delivery_date: '',
    //   transport_company: '',
    //   email_1: '',
    //   email_2: '',
    //   email_3: '',
    //   email_4: '',
    //   contact_person_name: '',
    //   contact_person_mobile: '',
    //   delivery_emp_id: '',
    //   delivery_address: '',
    //   delivery_latitude: '',
    //   delivery_longitude: '',
    //   household: false,
    //   school: false,
    //   school_name: '',
    // }
  }

  validateLoadsheetDetails(): ValidationErrors {
    return (group: FormGroup): ValidationErrors => {
      if (group.controls['school'].value === false && group.controls['household'].value === false) {
        return { required: true }
      }

      if (group.controls['school'].value === true && group.controls['school_name'].value.trim() === '') {
        return { school_name: true }
      }
      return null;
    }
  }

  atLeastOneValidator = (validator: ValidatorFn | ValidatorFn[]) => (group: FormGroup): ValidationErrors | null => {

    const runValidators = (control: AbstractControl): ValidationErrors => {
      if (Array.isArray(validator)) {
        for (let index = 0; index < validator.length; index++) {
          const errors = validator[index](control);
          if (errors) {
            return errors;
          }
        }
      } else {
        return validator(control);
      }
    }

    const hasAtLeastOne =
      group &&
      group.controls &&
      Object.keys(group.controls).some(key => !runValidators(group.controls[key]));

    return hasAtLeastOne ? null : { atLeastOne: true };
  };

  submit() {
    markAsTouchDeep(this.form);

    if (!this.form.invalid) {
      this.createLoadsheetDelivery();
    }
  }

}
